import { FaCheckCircle, FaTimesCircle, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa"
import ReactDOMServer from "react-dom/server";
import "./Message.css"

const MessageManager = (() => {
  let toastContainer = null
  let bannerContainer = null
  const activeToasts = []

  // Initialize containers
  const initContainers = () => {
    if (!toastContainer) {
      toastContainer = document.createElement("div")
      toastContainer.id = "message-toast-container"
      toastContainer.className = "msg-toast-container"
      document.body.appendChild(toastContainer)
    }
    if (!bannerContainer) {
      bannerContainer = document.getElementById("message-banner-container")

      if (!bannerContainer) {
        bannerContainer = document.createElement("div")
        bannerContainer.id = "message-banner-container"
        bannerContainer.className = "msg-banner-container"
        document.body.appendChild(bannerContainer)
      }
    }
  }

  // Create toast notification
  const createToast = (type, message) => {
    initContainers()

    const toastId = `toast-${Date.now()}-${Math.random()}`
    const toastEl = document.createElement("div")
    toastEl.id = toastId
    toastEl.className = `msg-toast msg-toast-${type}`

    const iconComponent = getIconComponent(type)
    const closeBtn = document.createElement("button")
    closeBtn.className = "msg-toast-close"
    closeBtn.innerHTML = "&times;"
    closeBtn.setAttribute("aria-label", "Close notification")

    toastEl.innerHTML = `
      <div class="msg-toast-content">
        <span class="msg-toast-icon">${iconComponent}</span>
        <span class="msg-toast-message">${escapeHtml(message)}</span>
      </div>
    `
    toastEl.appendChild(closeBtn)

    closeBtn.addEventListener("click", () => {
      removeToast(toastId)
    })

    toastContainer.appendChild(toastEl)
    activeToasts.push(toastId)

    // Auto-dismiss after 3 seconds
    const timeout = setTimeout(() => {
      removeToast(toastId)
    }, 3000)

    // Store timeout ID for manual cleanup
    toastEl.timeoutId = timeout

    return toastId
  }

  // Remove toast notification
  const removeToast = (toastId) => {
    const toastEl = document.getElementById(toastId)
    if (toastEl) {
      clearTimeout(toastEl.timeoutId)
      toastEl.classList.add("msg-toast-exit")
      setTimeout(() => {
        if (toastEl.parentNode) {
          toastEl.parentNode.removeChild(toastEl)
        }
        activeToasts.splice(activeToasts.indexOf(toastId), 1)
      }, 300)
    }
  }

  // Create banner notification
  const createBanner = (
    type,
    message,
    actions = [],
    options = {},
  ) => {
    initContainers()

    const bannerId = `banner-${Date.now()}-${Math.random()}`
    const bannerEl = document.createElement("div")
    bannerEl.id = bannerId
    bannerEl.className = [
      "msg-banner",
      `msg-banner-${type}`,
      options.className,
    ]
      .filter(Boolean)
      .join(" ")

    const iconComponent = getIconComponent(type)

    let actionsHTML = ""
    if (actions && actions.length > 0) {
      actionsHTML = '<div class="msg-banner-actions">'
      actions.forEach((action) => {
        actionsHTML += `<button class="msg-banner-btn msg-banner-btn-${action.type || "primary"}">${escapeHtml(action.label)}</button>`
      })
      actionsHTML += "</div>"
    }

    bannerEl.innerHTML = `
      <div class="msg-banner-wrapper">
        <span class="msg-banner-icon">${iconComponent}</span>
        <p class="msg-banner-message">
          ${escapeHtml(message)}
          <button class="msg-banner-reload">Refresh page</button>
        </p>
        <div class="msg-banner-right">
          ${actionsHTML}
        </div>
      </div>
    `

    bannerContainer.appendChild(bannerEl)

    const reloadLink = bannerEl.querySelector(".msg-banner-reload")
    if (reloadLink) {
      reloadLink.addEventListener("click", () => window.location.reload())
    }

    // Attach click handlers to action buttons
    const buttons = bannerEl.querySelectorAll(".msg-banner-btn")
    buttons.forEach((btn, index) => {
      if (actions[index] && actions[index].onClick) {
        btn.addEventListener("click", actions[index].onClick)
      }
    })

    return bannerId
  }

  // Remove banner notification
  const removeBanner = (bannerId) => {
    const bannerEl = document.getElementById(bannerId)
    if (bannerEl) {
      bannerEl.classList.add("msg-banner-exit")
      setTimeout(() => {
        if (bannerEl.parentNode) {
          bannerEl.parentNode.removeChild(bannerEl)
        }
      }, 300)
    }
  }

 const getIconComponent = (type) => {
  const iconClasses = "msg-icon-element";

  const icons = {
    success: <FaCheckCircle className={iconClasses} />,
    error: <FaTimesCircle className={iconClasses} />,
    warning: <FaExclamationTriangle className={iconClasses} />,
    info: <FaInfoCircle className={iconClasses} />,
  };

  const element = icons[type] || icons.info;

  // Convert React component → SVG HTML string
  return ReactDOMServer.renderToString(element);
};

  // Escape HTML to prevent XSS
  const escapeHtml = (text = "") => {
    const map = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    }
    return String(text).replace(/[&<>"']/g, (char) => map[char])
  }

  return {
    // Public API
    showToast: (type, message) => {
      return createToast(type, message)
    },
    removeToast: (toastId) => {
      removeToast(toastId)
    },
    showBanner: (
      type,
      message,
      actions = [],
      options = {},
    ) => createBanner(type, message, actions, options),
    removeBanner: (bannerId) => {
      removeBanner(bannerId)
    },
    // Clear all toasts and banners
    clearAll: () => {
      activeToasts.forEach((toastId) => removeToast(toastId))
      if (bannerContainer) {
        const banners = bannerContainer.querySelectorAll('[id^="banner-"]')
        banners.forEach((banner) => removeBanner(banner.id))
      }
    },
  }
})()

export default MessageManager

